import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const RecreationalTrainingProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Recreational Training Program</h2>
                            <p>
                                The Recreational Training Program at Net Nest Badminton Sports Club is designed for individuals who want to enjoy badminton in a relaxed and friendly environment while improving their fitness and basic playing skills. This program focuses on fun, wellness, and active living rather than competitive pressure, making it ideal for players of all ages.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Our recreational program blends light coaching with enjoyable gameplay, allowing participants to learn and play badminton at their own pace. It is perfect for those who want to stay fit, relieve stress, and experience the joy of badminton without the demands of professional training.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Recreational Training Program.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fun-Focused Learning Approach</h2>
                            <p>
                                Basic badminton strokes and simple techniques
                                <br></br>
                                Easy footwork and court movement
                                <br></br>
                                Rally play and shot consistency
                                <br></br>
                                Enjoyable drills that keep sessions engaging
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Fitness & Wellness Benefits</h2>
                            <p>
                                Cardiovascular health and stamina
                                <br></br>
                                Agility, balance, and coordination
                                <br></br>
                                Muscle tone and flexibility
                                <br></br>
                                Overall physical fitness and energy levels
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Stress Relief & Mental Refreshment</h2>
                            <p>
                                Mental relaxation and focus
                                <br></br>
                                Reduction in daily stress and fatigue
                                <br></br>
                                Improved mood and emotional well-being
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexible Timings for Convenience</h2>
                            <p>
                                Working professionals
                                <br></br>
                                College students
                                <br></br>
                                Adults returning to sports
                                <br></br>
                                Fitness enthusiasts
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Social Interaction & Community Spirit</h2>
                            <p>
                                Friendly matches and group play
                                <br></br>
                                Team bonding and social interaction
                                <br></br>
                                A welcoming badminton community
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Safe & Comfortable Playing Environment</h2>
                            <p>
                                Well-maintained indoor courts
                                <br></br>
                                Proper lighting and quality flooring
                                <br></br>
                                Safe training practices and guidance
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Suitable for All Age Groups</h2>
                            <p>
                                Beginners exploring badminton
                                <br></br>
                                Adults seeking fitness through sports
                                <br></br>
                                Casual players wanting structured play
                                <br></br>
                                Non-competitive badminton enthusiasts
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RecreationalTrainingProgram;